import { render, staticRenderFns } from "./nextCompetition.vue?vue&type=template&id=01b70450&"
import script from "./nextCompetition.vue?vue&type=script&lang=js&"
export * from "./nextCompetition.vue?vue&type=script&lang=js&"
import style0 from "./nextCompetition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports